import { connect } from 'react-redux';

import RegistrationView from '../components/RegistrationView';

const mapActionCreators = {};

const mapStateToProps = state => ({
    isFetching: state.registration.get('isFetching'),
});

export default connect(
    mapStateToProps,
    mapActionCreators
)(RegistrationView);
